import { catchError, map } from 'rxjs/operators';
import { forkJoin, Observable, of } from 'rxjs';
import { deepmerge } from 'deepmerge-ts';
import { HttpBackend, HttpClient } from '@angular/common/http';

import { FileHashPipe } from '@iss/wo-common/hash-files';

export class MultiTranslateHttpLoader {
  constructor(
    private readonly handler: HttpBackend,
    private readonly fileHashPipe: FileHashPipe,
    private readonly resourcesPrefix: readonly (Readonly<{ prefix: string; suffix: string }> | string)[],
  ) {}

  public getTranslation(lang: string): Observable<unknown> {
    const requests = this.resourcesPrefix.map((resource) => {
      const path = this.fileHashPipe.transform(typeof resource === 'string' ? `${ resource }${ lang }.json` : `${ resource.prefix }${ lang }${ resource.suffix || '.json' }`);
      return new HttpClient(this.handler).get(path).pipe(catchError(() => {
        console.error('Something went wrong for the following translation file:', path);
        return of({});
      }));
    });
    return forkJoin(requests).pipe(map((response) => deepmerge(...response)));
  }
}
